import { render, staticRenderFns } from "./NovoDocumento.vue?vue&type=template&id=4d341d3b"
import script from "./NovoDocumento.vue?vue&type=script&lang=js"
export * from "./NovoDocumento.vue?vue&type=script&lang=js"
import style0 from "./NovoDocumento.vue?vue&type=style&index=0&id=4d341d3b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports